var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-header d-flex align-items-center" },
          [
            _c("SPAN", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("pgettext")("Fees", "ContractService")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _vm.items && _vm.items.length
              ? _c("SPAN", { staticClass: "badge badge-secondary ml-2" }, [
                  _vm._v("\n        " + _vm._s(_vm.items.length) + "\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loaded
              ? _c("ItpFormSelect2", {
                  staticClass: "ml-3",
                  style: _vm.b_6705964765214521_style,
                  attrs: {
                    name: "selectedFee",
                    "bind-object": "",
                    options: _vm.items,
                    "use-option-template-for-selected-option": "",
                    optionTemplate:
                      '<UcContractServiceFeeCard :item="option"></UcContractServiceFeeCard>'
                  },
                  model: {
                    value: _vm.selectedItem,
                    callback: function($$v) {
                      _vm.selectedItem = $$v
                    },
                    expression: "selectedItem"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _vm.selectedItem
              ? _c("ContractServiceFee", {
                  attrs: {
                    oid: _vm.selectedItem.id,
                    "no-header": "",
                    "no-footer": "",
                    displayParent: _vm.b_3943151158818434_displayParent,
                    "inline-commands": ""
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }